/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { isFluidPackage, } from "@fluidframework/container-definitions/internal";
export var ReconnectMode;
(function (ReconnectMode) {
    ReconnectMode["Never"] = "Never";
    ReconnectMode["Disabled"] = "Disabled";
    ReconnectMode["Enabled"] = "Enabled";
})(ReconnectMode || (ReconnectMode = {}));
/**
 * Gets the name of the Fluid package.
 * @param codeDetails- - Data structure used to describe the code to load on the Fluid document
 */
export const getPackageName = (codeDetails) => {
    // TODO: use a real type
    // This is the normal path that any modern customer would hit
    const containerPackageName = isFluidPackage(codeDetails?.package)
        ? codeDetails?.package.name
        : codeDetails?.package;
    return { name: containerPackageName };
};
//# sourceMappingURL=contracts.js.map